const DEFAULT_MAX_LENGTH = 64

export const truncateString = (
  str: string | undefined | null,
  maxLength: number = DEFAULT_MAX_LENGTH,
) => {
  if (!str) {
    return str
  }

  if (str.length <= maxLength) {
    return str
  }

  return str.substring(0, maxLength) + "…"
}

export const prettyIsJson = (str: string, format: boolean) => {
  try {
    return JSON.stringify(JSON.parse(str), null, format ? 2 : undefined)
  } catch {
    return null
  }
}

export const firstUpper = (str: string) =>
  str.charAt(0).toUpperCase() + str.slice(1)

// Poor but good enough for now
export const pluralise = (str: string, count: number) =>
  `${count} ${str}${count === 1 ? "" : "s"}`
